import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  createDailyReport, fetchAdminChildrenAttendance, fetchChildAttendance, markAllPresentChild, updateAttendanceStatus, updateChildAttendance, UpdateChildInfo, UpdateChildStatus, updateDailyReport, } from "../../../service/api";


export const getChildAttendance = createAsyncThunk(
    "attendance/getAttendance",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildAttendance(params)
            console.log("child attendance", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getAdminChildAttendance = createAsyncThunk(
    "attendance/getAdminSide",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAdminChildrenAttendance(params)
            console.log("child attendance", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editChildAttendance = createAsyncThunk(
    "attendance/markAttendance",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateChildAttendance(formValue)
            if (response.status === 201) {
                console.log("edit child attendance ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editMarkAllPresentChildUrl = createAsyncThunk(
    "attendance/markAll",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await markAllPresentChild(formValue)
            if (response.status === 201) {
                console.log("mark all attendance ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addChildDailyReport = createAsyncThunk(
    "attendance/addReport",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createDailyReport(formValue)
            if (response.status === 201) {
                console.log("child report", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editChildReport = createAsyncThunk(
    "attendance/editReport",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateDailyReport(formValue)
            if (response.status === 201) {
                console.log("edit report ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editAttendanceStatus = createAsyncThunk(
    "attendance/status",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateAttendanceStatus(formValue)
            if (response.status === 201) {
                console.log("child attendance status ", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const childAttendanceSlice = createSlice({
    name: "childAttendance",
    initialState: {
        adminChildAttendance: [],
        childAttendanceList: [],
        childReportList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        room: "",
        dob: "",
    },

    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setRoomFilter: (state, action) => {
            state.room = action.payload;
        },
        setDobFilter: (state, action) => {
            state.dob = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
        // GET STAFF SIDE
            .addCase(getChildAttendance.pending, (state) => {
                state.isLoading = true;
                    state.error = null
            })
            .addCase(getChildAttendance.fulfilled, (state, action) => {
                state.isLoading = false;
                const types = action.meta.arg.type === "Attendance";
                if (types) {
                    state.childAttendanceList = action.payload;

                } else {
                    state.childReportList = action.payload.data;
                }
            })
            .addCase(getChildAttendance.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // GET ADMIN SIDE
            .addCase(getAdminChildAttendance.pending, (state) => {
                state.isLoading = true;
                    state.error = null
            })
            .addCase(getAdminChildAttendance.fulfilled, (state, action) => {
                state.isLoading = false;
                state.adminChildAttendance=action.payload.data;
            })
            .addCase(getAdminChildAttendance.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // PUT
            .addCase(editChildReport.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editChildReport.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editChildReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


             // ATTENDANCE MARK
            .addCase(editChildAttendance.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editChildAttendance.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editChildAttendance.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


             // ALL MARK
            .addCase(editMarkAllPresentChildUrl.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editMarkAllPresentChildUrl.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editMarkAllPresentChildUrl.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // POST
            .addCase(addChildDailyReport.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addChildDailyReport.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addChildDailyReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editAttendanceStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editAttendanceStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editAttendanceStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


    }
})
export const { setSearchParams, setPagination, setRoomFilter, setDobFilter } = childAttendanceSlice.actions;

export default childAttendanceSlice.reducer;